var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.isConfirm)?_c('confirm'):_vm._e(),(_vm.isBadRequest)?_c('bad-request'):_vm._e(),(_vm.isNotFound)?_c('not-found'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }